<template>

  <div class="section section-white">

    <el-form v-model="form" label-width="160px">

      <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
      <el-form-item label="活动banner" hide-requied-aterisk="true">

        <div @click="handleImgPicker('banner')" class="upload-box">
          <img v-if="form.banner" :src="form.banner" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
      </el-form-item>
      <el-form-item label="主题分类(由发起者指定)">
        <el-select v-model="category_id" filterable  placeholder="请选择活动分类"  @change="search">
          <el-option v-for="item in category" :key="item.id" :label="item.category_name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="新增主题" class="addcategory">
        <el-input v-model="addcategorystr" placeholder="在聚合页中按分类">

        </el-input>
        <el-button type="primary" icon="" @click="handleAddCategory">主题分类</el-button>
      </el-form-item>

      <el-form-item label="活动名称">
        <el-input v-model="form.name"  placeholder="请输入活动名称"></el-input>
      </el-form-item>

      <el-form-item label="主办单位">
        <el-tag :key="item.distributor_id" class="new-tag" v-for="(item,index) in relDistributors" closable :disable-transitions="false" @close="handleClose(index)"> {{item.name}}
        </el-tag>
        <el-button size="medium" class="button-new-tag" @click="addDistributoreAction">+ 点击搜索店铺 </el-button>
      </el-form-item>
      <el-form-item label="主办单位联系电话">
        <el-input v-model="form.telphone"  placeholder="主办单位联系电话"></el-input>
      </el-form-item>
      <el-form-item label="活动地址">
        <el-input v-model="form.address"  placeholder="活动地址"></el-input>
      </el-form-item>
      <el-form-item label="适用人群">
        <el-input v-model="form.for_crowd"  placeholder="请输入适用人群"></el-input>
      </el-form-item>
      <!-- <el-form-item label="活动日期">
        <el-col :md="10" :lg="8">

          <el-date-picker
                  v-model="date_time" type="date" start-placeholder="活动时间"  size="mini"  value-format="timestamp"></el-date-picker>
        </el-col>
      </el-form-item> -->
      <el-form-item label="活动时间">
        <el-col :span="20">
            <el-date-picker
                    v-model="activity_date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="yyyy/MM/dd HH:mm:ss"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
        </el-col>
    </el-form-item>
      <!-- <el-form-item label="活动时间">
        <el-col :md="10" :lg="8">
          <el-time-picker
                  is-range
                  v-model="active_time_f"
                  range-separator="至"
                  value-format="HH:mm"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  @change="dateChange2"
          >
          </el-time-picker>

        </el-col>
      </el-form-item> -->
      <el-form-item label="截止报名时间">
        <el-col :md="10" :lg="8">
          <el-date-picker
                  v-model="deadline_time"
                  type="datetime"
                  value-format="timestamp"
                  default-time="23:59:59"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="最大报名人数" :rules="rules.max_num">
        <el-input-number v-model="form.max_num"   type='number' placeholder="最大报名人数"> </el-input-number>
      </el-form-item>
      <el-form-item label="报名次数" :rules="rules.max_num_time">
        <el-input-number v-model="form.max_num_time"   type='number' placeholder="报名次数"> </el-input-number>
      </el-form-item>
      <el-form-item label="支付金额">
        <el-input-number v-model="form.pay_money"   type='number' placeholder="支付金额"> </el-input-number>
      </el-form-item>
      <el-form-item label="前端显示是否可退款">
        <el-switch v-model="form.show_can_refund" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item label="是否发放优惠券">
        <el-switch v-model="form.send_card_flag"  active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <div class="showcardsconfig" :class="form.send_card_flag ? 'show':'hidden'">
        <div slot="header" class="clearfix">
          <span>优惠券信息</span>
           <el-button @click="addDomain('rule')" size="mini" type="primary" >新增优惠券+</el-button>
        </div>
        <div  class="text item">
             <div  v-for="(item, index) in form.rule"  :key="item.key">
                   <el-form-item
                     :label="'优惠券编码' "
                     :prop="'rule.' + index + '.card_id'"
                      :rules="[
                        {required: true, message: '优惠券信息'},
                      ]"
                     style="display: inline-block;"
                   >
                   <el-input v-model="item.card_id" size="mini" type="text"  placeholder="请输入优惠券编码" ></el-input>
                   </el-form-item>
                   <el-button  type="primary" size="mini"  @click.prevent="removeDomain(item,'rule')" >X</el-button>
             </div>
          </div>
      <!-- <el-form-item label="优惠券图">
        <div @click="handleImgPicker('card')" class="upload-box">
          <img v-if="form.card_img" :src="form.card_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
      </el-form-item> -->
      <!-- <el-form-item label="优惠券(互动活动)">
        <el-form-item
                v-for="(item, index) in form.rule"
                :label="'优惠券.' + (index+1) "
                :key="index"
                :prop="'rule.' + index + '.value'"
               >
          <el-select v-model="item.card_id" @change="changeCard(index)" placeholder="请选择优惠券" filterable >
            <el-option :label="v.title" :value="v.card_id" v-for="(v,i) in cardList" :key="v.card_id" ></el-option>
          </el-select>

          <el-input type="text" v-model="item.info" style="display: none" ></el-input>
          <el-button @click.prevent="removeRule(item)">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addRule"  >+优惠券</el-button>
      </el-form-item> -->

      <!-- <el-form-item label="线下优惠券（互动活动）">
        <el-form-item
                v-for="(item, index) in form.rule2"
                :label="'线下优惠券.' + (index+1) "
                :key="index"
                :prop="'rule2.' + index + '.value'"
                >
          <el-select v-model="item.id" @change="changeCard2(index)" placeholder="请选择优惠券" filterable >
            <el-option :label="v.apprange_name" :value="v.id" v-for="(v,i) in cardList2" :key="v.id" ></el-option>
          </el-select>

          <el-input type="text" v-model="item.info" style="display: none" ></el-input>
          <el-button @click.prevent="removeRule2(item)">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addRule2"  >+线下优惠券</el-button>
      </el-form-item> -->
      </div>
      <!-- <el-form-item label="是否发布">
        <el-switch
                v-model="form.status_flag"
                active-color="#13ce66"
                inactive-color="#ff4949">
        </el-switch>
      </el-form-item> -->

        <el-card header="图文详情" shadow="never" v-loading="">
          <template v-if="mode === 'richText'">
            <vue-html5-editor :content="form.contents" ref="editor" @change="updateContent" :height="360"></vue-html5-editor>
            <span class="tpl_item img" @click="addImgPreview" style="">
            <i class="iconfont icon-image"></i>添加图片
          </span>
          </template>
          <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>
        </el-card>


    </el-form>
    <!-- <template slot-scope="scope"> -->
      <div slot="footer" class="dialog-footer content-center">
        <el-button type="primary" @click="handleSave" v-if="this.form.status_flag == 0" :loading="submitLoading">确定</el-button>
        <el-button type="primary"@click.native="handleCancel" v-else :loading="submitLoading">返回列表</el-button>
      </div> 
    <!-- </template> -->
    <DistributorSelect :store-visible="DistributorVisible" :is-valid="isValid" :rel-data-ids="relDistributors" :get-status="DistributorStatus" @chooseStore="DistributorChooseAction" @closeStoreDialog="closeDialogAction"></DistributorSelect>
  </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import {saveDistributorselfActivity,getDistributorselfActivityDetail,getDistributorActivityCategoryList,addDistributorActivityCategory} from '../../../../api/marketing'
    import {getCardListnoAuth,getOfflineListnoAuth} from '../../../../api/cardticket'
    import DistributorSelect from '@/components/function/distributorSelect'
    import richTextEditor from '@/components/function/richTextEditor'
    import imgPicker from '@/components/imageselect'
    export default {
        // inject: ['refresh'],
        components: {
            imgPicker,
            DistributorSelect,
            richTextEditor,
        },
        data () {
            return {
              rules: {
                  max_num: [
                    {required: true, message: '请输入最大报名人数'},
                  ],
                  max_num_time: [
                    {required: true, message: '请输入最大报名次数'},
                  ]
                },
                pickerImgType: "",
                category:[],
                category_id:'',
                addcategorystr:'',
                copy_flag:false,
                clickable:false,
                dialog: false,
                distributor_dialog:false,
                relDistributors:[],
                DistributorVisible: false,
                DistributorStatus: false,
                isValid: true,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                DistributorName:'',
                pay_money:'',
                send_card_flag:'',
                show_can_refund:'',
                form: {
                    id:'',
                    name:'',
                    distributor_id:[],
                    address:'',
                    banner:'',
                    contents:'',
                    // date_time:'',
                    // active_time:'',
                    activity_date:'',
                    organizer:[],
                    deadline_time:'',
                    max_num:'',
                    max_num_time:'',
                    status_flag:false,
                    telphone:'',
                    for_crowd:'',
                    pay_money:0,
                    category_id:0,
                    category_name:'',
                    show_can_refund:false,
                    send_card_flag:false,
                    rule: [{
                      card_id:''
                    }],
                    rule2: [{
                        card_id:'',
                        card_name:'',
                        card_yh_price:'',
                    }]
                },
                cardList: [],
                cardList2:[],
                // active_time_f : '',
                activity_date:'',
                deadline_time : '',
                // date_time : '',
                distributor_from:{
                    id:'',
                    distributor_id:[],
                    image:'',
                    ad_desc:'',
                    distributor_list:[],

                },
                mode: 'richText',
                thumbDialog:false,
                picsDialog: false,
                imgDialog: false,
                isGetImage: false,
                isGetThumb: false,
                imgIndex: 0,
                submitLoading:false,
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            getCard(){
                getCardListnoAuth({card_type:'cash',title:'互动活动',page:1,page_size:10000}).then(res=>{
                    if(res.data){
                        this.cardList = res.data.data.list
                    }
                })
            },
            // getCard2(){
            //     //线下优惠券
            //     getOfflineListnoAuth({page:1,name:'互动活动',pageSize:10000}).then(res=>{
            //         if(res.data){
            //             this.cardList2 = res.data.data.list
            //         }
            //     })
            // },
            // addRule(){
            //     this.form.rule.push({
            //         card_id:'',
            //         card_name:'',
            //         card_yh_price:'',
            //     });

            // },
            removeDomain(item,rule) {
              this.$confirm("此操作将会移除此项是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  var index = this.form[rule].indexOf(item)
                  if (index !== -1) {
                    this.form[rule].splice(index, 1)
                  }
                })
                .catch(() => {});
              },
            addDomain(rule) {
              this.form.rule.push({});
            },
            // removeRule(item){
            //     var index = this.form.rule.indexOf(item)
            //     if (index !== -1) {
            //         this.form.rule.splice(index, 1)
            //     }
            // },
            // changeCard(index){
            //     var card = this.form.rule[index].card_id
            //     var i=this.cardList.map((item) => item.card_id).indexOf(card);
            //     // this.form.rule[index].info=JSON.stringify(this.cardList[i]);
            //     this.form.rule[index].card_id = this.cardList[i].card_id;
            //     this.form.rule[index].card_name = this.cardList[i].title;
            //     this.form.rule[index].card_yh_price = this.cardList[i].reduce_cost / 100 ;
            // },
            // addRule2(){
            //     console.log(this.form.rule2.length)
            //     this.form.rule2.push({
            //         card_id:'',
            //         card_name:'',
            //         card_yh_price:'',
            //     });

            // },
            // removeRule2(item){
            //     var index = this.form.rule2.indexOf(item)
            //     if (index !== -1) {
            //         this.form.rule2.splice(index, 1)
            //     }
            // },
            // changeCard2(index){
            //     var card = this.form.rule2[index].id
            //     var i=this.cardList2.map((item) => item.id).indexOf(card);
            //     // this.form.rule2[index].info=JSON.stringify(this.cardList2[i]);
            //     this.form.rule2[index].card_id = this.cardList2[i].id;
            //     this.form.rule2[index].card_name = this.cardList2[i].apprange_name;
            //     this.form.rule2[index].card_yh_price = this.cardList2[i].perputoutvalue;
            // },
            dateChange2(val){
                // 具体活动时间 时分秒
                if (val.length > 0) {
                    console.log(val)
                    this.form.active_time = val[0] + '-' + val[1];
                    console.log(this.form.active_time)
                } else {
                    this.form.active_time = ''
                }
            },
            getCategoryList(){
                getDistributorActivityCategoryList().then(res=>{
                    if(res.data.data.list){
                        this.category = res.data.data.list
                    }
                })
            },
            search () {
                this.form.category_id = this.category_id
                for(var i=0;i<this.category.length;i++){
                    console.log((this.category[i]))
                    if(this.category[i].id == this.category_id){
                        this.form.category_name = this.category[i].category_name
                    }
                }
              console.log(this.form.category_name)
            },
            handleAddCategory(){
                if(this.addcategorystr == ''){
                    return false
                }
                addDistributorActivityCategory({'category_name':this.addcategorystr}).then(res=>{
                  console.log(res,'2222222222222')
                    if(res.data.data.status){
                        this.$message({
                            message: '添加成功',
                            type: 'success',
                        })
                        this.getCategoryList()
                        this.addcategorystr = ''
                    }else{
                        this.$message.error(res.data.data.msg);
                    }
                })

            },
            handleCancel () {
              this.$router.back(-1)
            },
            updateContent: function (data) {
                this.form.contents = data
            },
            handleClose(index) {
                this.relDistributors.splice(index, 1);
                this.form.distributor_id.splice(index, 1);
                console.log(this.form.distributor_id,'888888888888')
            },
            DistributorChooseAction (data) {
              this.DistributorVisible = false
              this.DistributorStatus = false
              if (data === null || data.length <= 0) return
              this.relDistributors = data
            },
            // DistributorChooseAction (data) {
            //     this.DistributorVisible = false
            //     this.DistributorStatus = false
            //     console.log(data.length,'111111111111111111')
            //     if (data === null || data.length <= 0) return
            //     if (data.length > 0) {
            //       data.forEach( data => {
            //         this.form.distributor_id.push(data.distributor_id);
            //       })
            //       data.forEach( data => {
            //         this.form.organizer.push({
            //           distributor_id: data.distributor_id,name:data.name});
            //       })
            //     }
            //     console.log(this.form.distributor_id,'22222222222222222')
            //     this.relDistributors = data
            //     // this.form.distributor_id = data[0].distributor_id
            //     if(data.length >1){
            //       this.form.address = '门店';
            //     }else{
            //         this.form.address = data[0].address
            //     }
                
            //     // this.form.organizer = data[0].name

            //     this.distributor_from.distributor_list = data
            // },
            closeDialogAction () {
                this.DistributorStatus = false
                this.DistributorVisible = false
            },
            handleAdd () {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            addDistributoreAction() {
                this.DistributorVisible = true
                this.DistributorStatus = true
            },

            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
            },
            // 详情中的上传图片
            addImgPreview: function () {
                this.thumbDialog = true
                this.isGetThumb = true
            },
            closeThumbDialog: function () {
                this.thumbDialog = false
                this.isGetThumb = false
            },
            pickThumb: function (arr) {
                if (arr.length != 0) {
                    arr.forEach(data => {
                        if (data && data.url !== '') {
                            this.thumbDialog = false
                            var index = this.$refs.editor.$el.id
                            var loc = this.$refs.editor
                            var img = new Image()
                            img.src = this.wximageurl + data.url
                            if (loc.range) {
                                loc.range.insertNode(img)
                                var referenceNode = loc.range.endContainer
                                if (referenceNode.className !== 'content') {
                                    loc.range.setStartAfter(referenceNode)
                                } else {
                                    loc.range.setStart(loc.range.endContainer, loc.range.endOffset)
                                }
                            } else {
                                loc.$refs.content.appendChild(img)
                                loc.focus()
                                loc.restoreSelection()
                            }
                            this.form.contents = loc.$refs.content.innerHTML
                        }
                    })
                }
            },

            // 保存
            handleSave(){
                this.form.distributor_id = []
                this.form.organizer = []
                if(this.relDistributors.length > 0) {
                  console.log(this.relDistributors,'提交的店铺数据')
                  this.relDistributors.forEach( distributor => {
                      this.form.distributor_id.push(distributor.distributor_id);
                    })
                    this.relDistributors.forEach( distributor => {
                      this.form.organizer.push({
                        distributor_id: distributor.distributor_id,name:distributor.name});
                    })
                  // this.relDistributors.forEach( distributor => {
                  //   this.form.distributor_id.push({distributor_name: distributor.name, distributor_id: distributor.distributor_id});
                  // })
                }
                if(this.form.distributor_id.length == 0){
                  this.form.distributor_id = 'all'
                  // this.$message.error('请选择店铺!')
                  // return
                }
                if(this.deadline_time == 0){
                  this.$message.error('请选择截止报名时间!')
                  return
                }
                this.form.deadline_time = this.deadline_time / 1000
                // this.form.date_time = this.date_time / 1000
                const that = this
                if (this.activity_date.length > 0) {
                  this.form.date_time = this.activity_date[0] / 1000
                  this.form.active_time = this.activity_date[1] / 1000
                }else{
                  this.$message.error('请选择活动起始时间!')
                  return
                }
                console.log(this.form,'保存成功')
                saveDistributorselfActivity(this.form).then(res => {
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        duration: 2 * 1000,
                        onClose () {
                            that.$router.go(-1)
                        }
                    })
                }).catch( error  => {
                    this.$message.error('添加失败!')
                    this.submitLoading = false
                })
            },
            handleImgPicker (pickerImgType) {
                this.pickerImgType = pickerImgType
                this.imgDialog = true
                this.isGetImage = true
            },
            pickImg (data) {
                if(this.pickerImgType == "card"){
                    this.form.card_img = data.url
                }else{
                    this.form.banner = data.url
                }

                this.imgDialog = false
            },
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
            getDetail(id){
                getDistributorselfActivityDetail(id).then(res=>{
                    let data = {
                        // 复制活动提交去掉秒杀id
                        id: this.copy_flag ? '' : res.data.data.id,
                        name:res.data.data.name,
                        address:res.data.data.address,
                        banner:res.data.data.banner,
                        distributor_id:this.copy_flag ? '' : res.data.data.distributor_id,
                        contents:res.data.data.contents,
                        organizer:res.data.data.organizer,
                        deadline_time:res.data.data.deadline_time,
                        max_num:res.data.data.max_num,
                        max_num_time:res.data.data.max_num_time,
                        // active_time:res.data.data.active_time,
                        status_flag:res.data.data.status_flag,
                        telphone:res.data.data.telphone,
                        for_crowd:res.data.data.for_crowd,
                        card_img:res.data.data.card_img,
                        category_id:res.data.data.category_id,
                        category_name:res.data.data.category_name,
                        pay_money:res.data.data.pay_money / 100,
                        send_card_flag: res.data.data.send_card_flag,
                        show_can_refund: res.data.data.show_can_refund,
                        rule:res.data.data.card_msg,
                        rule2:res.data.data.xxcard_msg,
                    }
                    Object.assign(this.form, data)
                    // this.date_time = res.data.data.date_time * 1000
                    this.deadline_time = res.data.data.deadline_time * 1000
                    // this.active_time_f = res.data.data.active_time_f
                    this.activity_date = [res.data.data.date_time * 1000, res.data.data.active_time * 1000]
                    this.category_id = res.data.data.category_id


                    this.relDistributors = this.copy_flag ? [] :res.data.data.distributormsg.list
                })
            }
        },
        mounted () {
            this.getCategoryList()
            // this.getCard2()
            this.getCard()
            if (this.$route.params.id) {
                this.getDetail(this.$route.params.id);
            }
            // 复制活动
            if (this.$route.query.copyid){
                this.copy_flag = true
                this.getDetail(this.$route.query.copyid);
            }
        }

    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .addcategory{
    display:inline-block;
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
  .vue-html5-editor {
    width: 80%;
  }
  .hidden{
    display:none
  }
  .show{
    display:block
  }
</style>



// WEBPACK FOOTER //
// edit.vue?5e38acc4